import uppercase from './uppercase';
import formatDate from './formatDate';
import pluralize from './pluralize';


export default {
  install(Vue) {
    Vue.filter('uppercase', uppercase);
    Vue.filter('formatDate', formatDate);
    Vue.filter('pluralize', pluralize);
  }
}
